import httpClient from './httpClient';

const prefix = 'core'

export default {
    async getLeaveUserAll () {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getLeaveUserAll`)
        return data
    },
    async getWithdrawUserByCompany () {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getWithdrawUserByCompany`)
        return data
    },
    async getLeaveUserNotiByCompany () {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getLeaveUserNotiByCompany`)
        return data
    },
    async getWithdrawUserByCompanyAndId (id) {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getWithdrawUserByCompanyAndId/${id}`)
        return data
    },
    async isReadLeaveUserId(id){
        const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/is_read/`+id)
        return data
    }
    // async deleteLeaveUser (id) {
    //     const { data } = await httpClient({ requiresAuth: true }).delete(`${prefix}/deleteLeaveUser/${id}`)
    //     return data
    // }
}